module.exports = __webpack_public_path__ + "img/avatar.3aaf0b11.jpg";